import React from "react";
import { Carousel } from "react-bootstrap";
const Showimage = ({ imagelist,showSlide }) => {

  return (
    <Carousel>
      {imagelist &&
        imagelist.length > 0 &&
        imagelist.map((item, index) => {
          return (
            <Carousel.Item key = { index }
           
            >
              <img
                key={index}
                className="d-block w-100"
                src={item.ImageURL}
                alt="First slide"
              />
              <Carousel.Caption>
              <p>{"ลำดับที่ "+ item.no}</p>
            <p>{item.checktime}</p>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
    </Carousel>
  );
};

export default Showimage;
